// Adrise Volumetric Fee Structure
// No subscription. The only charge is a top-up fee that depends on monthly spend bracket and vertical class.
// Rates are intentionally set below prevailing market levels.

export const VOLUME_TIERS = [
    { id: "starter", name: "Starter", label: "Under $250k / mo", min: 0, max: 250_000, whiteHat: 2.5, grayHat: 4, casino: 7, cashback: null, accent: "#7C766B", description: "Welcome tier. Onboard, find your hooks, validate your funnel." },
    { id: "pro", name: "Pro", label: "$250k – $500k / mo", min: 250_000, max: 500_000, whiteHat: 2, grayHat: 3.5, casino: 6.5, cashback: null, accent: "#9C968A", description: "First scaling threshold. White-hat drops to 2%, gray-hat to 3.5%." },
    { id: "scale", name: "Scale", label: "$500k – $1M / mo", min: 500_000, max: 1_000_000, whiteHat: 1.75, grayHat: 3, casino: 6, cashback: { min: 0.5, max: 1 }, accent: "#C9C3B6", description: "Serious operator tier. White-hat 1.75%, gray-hat 3%, casino 6%, plus 0.5–1% cashback." },
    { id: "whale", name: "Whale", label: "$1M – $2.5M / mo", min: 1_000_000, max: 2_500_000, whiteHat: 1.5, grayHat: 2.5, casino: 5.5, cashback: { min: 1, max: 2 }, accent: "#2FA57C", description: "White-hat 1.5%, gray-hat 2.5%, casino 5.5%. Plus 1–2% cashback on monthly spend." },
    { id: "titan", name: "Titan", label: "$2.5M+ / mo", min: 2_500_000, max: Infinity, whiteHat: 1, grayHat: 2, casino: 5, cashback: { min: 2, max: 3 }, accent: "#43C08E", description: "Lowest rates on the market: white-hat 1%, gray-hat 2%, casino 5%. Plus 2–3% cashback." },
];

export const VERTICAL_CLASSES = [
    {
        id: "whiteHat",
        name: "White-hat",
        examples: "E-commerce · DTC · SaaS · B2B · Lead Gen · Apps",
    },
    {
        id: "grayHat",
        name: "Gray-hat",
        examples:
            "Finance · Crypto · Nutra · Dating · Aggressive D2C · Health · Insurance",
    },
    {
        id: "casino",
        name: "Casino & Gambling",
        examples: "Online casino · Sportsbook · iGaming (licensed · all platforms)",
    },
];

// Instant credit added to your balance the moment a single top-up is confirmed.
export const DEPOSIT_BONUS_TIERS = [
    { min: 2_500, bonusPct: 2 },
    { min: 10_000, bonusPct: 4 },
    { min: 25_000, bonusPct: 6 },
    { min: 50_000, bonusPct: 8 },
];

export function getTierForSpend(spendUsd) {
    return (
        VOLUME_TIERS.find(
            (t) => spendUsd >= t.min && spendUsd < t.max,
        ) || VOLUME_TIERS[VOLUME_TIERS.length - 1]
    );
}

export function getDepositBonus(amountUsd) {
    let pct = 0;
    for (const t of DEPOSIT_BONUS_TIERS) if (amountUsd >= t.min) pct = t.bonusPct;
    return { bonusPct: pct, bonus: (amountUsd * pct) / 100 };
}

export function calculateMonthly(spendUsd, vertical = "grayHat") {
    const tier = getTierForSpend(spendUsd);
    const feePct = tier[vertical] ?? 0;
    const fee = (spendUsd * feePct) / 100;
    const cashbackPct =
        tier.cashback && vertical !== "casino" ? tier.cashback.max : 0;
    const cashback = (spendUsd * cashbackPct) / 100;
    const netCost = fee - cashback;
    return {
        tier,
        feePct,
        fee,
        cashbackPct,
        cashback,
        netCost,
    };
}
